/**
 * デバイス判定ユーティリティ関数
 */

/**
 * iOS デバイスかどうかを判定する（iPad Safari デスクトップモード対応）
 * @returns {boolean} iOS デバイスの場合 true
 */
export const isIOS = (): boolean => {
  const userAgent = navigator.userAgent;
  
  // 通常のiOS判定
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return true;
  }
  
  // iPad Safari デスクトップモード判定
  // Mac UserAgentでタッチイベントが利用可能な場合はiPadと判定
  if (userAgent.includes('Mac') && 'ontouchend' in document) {
    return true;
  }
  
  return false;
};

/**
 * Safari ブラウザかどうかを判定する
 * @returns {boolean} Safari ブラウザの場合 true
 */
export const isSafari = (): boolean => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

/**
 * プラットフォーム情報を取得する
 * @returns {object} プラットフォーム情報
 */
export const detectPlatform = () => {
  return {
    isIOS: isIOS(),
    isSafari: isSafari()
  };
};
